import { Box, Flex, HStack, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import TrackSraDetails from '../Components/TrackSraDetails'
import MainLayout from '../Layouts/Index'
import { AllApprovedInventoryAPI, AllSraProduct } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function TrackApprovedInventory() {
    const [Data, setData] = useState([]);
    const [SingleData, setSingleData] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const [PreLoader, setPreLoader] = useState(true);


    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentSra = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }




    const ReadAllApprovedInventory = async () => {
        let result = await AllApprovedInventoryAPI()

        console.log("ReadAllApprovedInventory", result);

        if (result.status == true) {
            setData(result.queryresult.sraproductdetails
            )
            setPreLoader(false)
        }
    }



    const [SearchText, setSearchText] = useState("");
    const [SelectStore, setSelectStore] = useState("");



    const moreDetails = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        setSingleData(singleInfo)
        onOpen()
    }

    const handleSelectStore = (e)=>{
        setSelectStore(e.target.value)

       


    }
  

    useEffect(() => {
        ReadAllApprovedInventory()
      
    }, [])
    return (
        <MainLayout>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Track Product Status" description='Eko Track Product Status' />
            <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                <Text textTransform="capitalize">Total Numbers of Product - {Data.length}</Text>

            </Flex>

            <Flex justifyContent="space-between" flexWrap="wrap" alignItems="center">
                <Box w={["100%","100%","100%","100%","48%"]}>

                <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"productName, ProductShelfId, Status"} />
                </Box>


                <Select w={["100%","100%","100%","100%","48%"]} borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={SelectStore != "" ? "16px" : "12px"} id='store' value={SelectStore} onChange={handleSelectStore}>

                    <option value="1" >Admin Store Marina</option> 
                    <option value="2" >Central Circle stores, Ijora</option>
                    <option value="3" >East Circle stores, Island</option>
                    <option value="4" >West Circle stores, Festac</option>

                </Select>
            </Flex>
            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Product Name</Th>
                                <Th color="#fff"> Product shelf id</Th>
                                <Th color="#fff"> IIR Number</Th>
                                <Th color="#fff">Date received</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">More details</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            {

                                SelectStore === "" ? (
                                    SearchText === ""   ? (
                                    currentSra.map((item, i) => (
                                        <TableRow
                                            type={"trackProduct"}
                                            sn={i + 1}
                                            productName={item.shelfid?.productname}
                                            productShelfId={item.shelfid?.productshelfid}

                                            itemNo={item.sra?.itemnos}

                                            dateReceived={moment(item.sra?.datereceived).format('DD/MM/YYYY')}
                                            status={item.status}
                                            onClick={() => moreDetails(item._id)}
                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid.toLowerCase().includes(SearchText.toLowerCase()) || item.status.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (
                                        Data.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid?.toLowerCase().includes(SearchText.toLowerCase()) || item.status.toLowerCase().includes(SearchText.toLowerCase()))
                                            .map((item, i) => (
                                                <TableRow
                                                    type={"trackProduct"}
                                                    sn={i + 1}
                                                    productName={item.shelfid?.productname}
                                                    productShelfId={item.shelfid?.productshelfid}
                                                    dateReceived={moment(item.sra?.datereceived).format('DD/MM/YYYY')}
                                                    status={item.status}
                                                    onClick={() => moreDetails(item._id)}
                                                />
                                            ))
                                    ) : (


                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                    )

                                )
                                ):(
                                    currentSra.filter(item => item.store === SelectStore)
                                    .map((item, i) => (
                                                <TableRow
                                                    type={"trackProduct"}
                                                    sn={i + 1}
                                                    productName={item.shelfid?.productname}
                                                    productShelfId={item.shelfid?.productshelfid}
                                                    dateReceived={moment(item.sra?.datereceived).format('DD/MM/YYYY')}
                                                    status={item.status}
                                                    onClick={() => moreDetails(item._id)}
                                                />
                                            ))
                                )

                               

                            }


                        </Tbody>

                    </Table>
                </TableContainer>


                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

            </Box>

            <TrackSraDetails isOpen={isOpen} onClose={onClose} singleData={SingleData} />

        </MainLayout>
    )
}
